import React, { useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill";
import Quill from "quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-hot-toast";
import ImageResize from "quill-image-resize-module-react";
import { uploadImageApi } from "../../api";

Quill.register("modules/imageResize", ImageResize);

var Parchment = Quill.import("parchment");

// console.log(Parchment);

const config = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ["1", "1_5", "2", "2_5", "3", "3_5"],
};

var LineHeightClass = new Parchment.Attributor.Class(
  "lineheight",
  "ql-lineHeight",
  config
);

Parchment.register(LineHeightClass);

function TextEditor({ content, handleChange, placeholder, smallEditor }) {
  // global variable
  const quillObj = useRef();
  const [loading, setLoading] = useState(false);

  const uploadFiles = (uploadFileObj, filename, quillObj) => {
    setLoading(true);

    uploadImageApi(uploadFileObj, "article")
      .then((res) => {
        const img_url = res.data.imageUrl;
        const range = quillObj.current.getEditorSelection();
        quillObj.current.getEditor().insertEmbed(range.index, "image", img_url);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Something went wrong while uploading image.");
        setLoading(false);
      });
  };

  const imageHandler = () => {
    const input = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input?.files[0];

      const fileName = file.name;

      const res = await uploadFiles(file, fileName, quillObj);
    };
  };

  const resizeImageWithAspectRatioLocal = (img, width, maxWidth) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Calculate the aspect ratio
    const aspectRatio = img.width / img.height;

    // Ensure the new width is within the maxWidth limit
    if (width > maxWidth) {
      width = maxWidth;
    }

    // Calculate the new height based on the aspect ratio
    const height = width / aspectRatio;

    // Set the canvas dimensions
    canvas.width = width;
    canvas.height = height;

    // Draw the image onto the canvas with the new dimensions
    ctx.drawImage(img, 0, 0, width, height);

    // Convert the canvas back to an image
    const resizedImage = new Image();
    resizedImage.src = canvas.toDataURL("image/jpeg");

    return resizedImage;
  };

  const modules = useMemo(
    () => ({
      // imageActions: {},
      // imageFormats: {},
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize", "Toolbar"],
        customResizeFunction: resizeImageWithAspectRatioLocal,
      },
      toolbar: {
        container: [
          [
            { header: "1" },
            { header: "2" },
            { header: [3, 4, 5, 6] },
            { font: [] },
          ],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["link", "image", "video"],
          ["clean"],
          [
            {
              lineheight: ["1", "1_5", "2", "2_5", "3", "3_5"],
            },
          ],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "color",
    "background",
    "align",
    "link",
    "image",
    "video",
    "align",
    "float",
    "lineheight",
  ];

  console.log(content);

  return (
    <div>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <ReactQuill
        ref={quillObj}
        className={smallEditor ? "quill-editor" : ""}
        style={{
          borderRadius: "15px",
          outline: "none",
          width: "100%",
        }}
        value={content}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder ? placeholder : ""}
      />
    </div>
  );
}

export default React.memo(TextEditor);
